export default "__VITE_PUBLIC_ASSET__fdd74e3b__"